import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalPenaltyAssessment } from '@/types/vehicle-withdrawal-penalty-assessment'
import { AxiosResponse } from 'axios'

export function deleteVehicleWithdrawalPenaltyAssessment(
  uuid: string
): Promise<AxiosResponse<VehicleWithdrawalPenaltyAssessment>> {
  return instance.delete(`/vehicle-withdrawal-penalty-assessment/${uuid}`)
}
